import { useIntl } from "react-intl";

export const useTranslator = () => {
  const intl = useIntl();
  
  return (translationId: string, prefix: string = "report") => {
    return intl.formatMessage({ id: `${prefix}.${translationId}`, defaultMessage: translationId });
  }
};
